
import { Injectable } from '@angular/core';
import { InMemoryDbService } from 'angular-in-memory-web-api';
import { Observable } from 'rxjs';
import { AuthDataContext } from '../../../../auth';
@Injectable()
export class FakeApiService implements InMemoryDbService {
	constructor() {}
	createDb(): {} | Observable<{}> {
		const db = {
			users: AuthDataContext.users,
			roles: AuthDataContext.roles,
			permissions: AuthDataContext.permissions,
			customers: '',
			products: '',
			productRemarks: '',
			productSpecs: '',
			orders: '',
			cars: "",
		};
		return db;
	}
}
